import {
  BrowserAuthManager,
  readBrowserConfig,
  type ConfigurationEnvironment,
} from "@groundspark/browser-auth";
import { installThemeColour } from "@groundspark/styles/colours";
import "@groundspark/styles/base";
import "./style.scss";
import { CanvassApplication } from "./app";
import { element, heading, message } from "./ui";

// Keep email capabilities out of request logs and referrers.
const fragment = location.hash;
if (fragment) history.replaceState(null, "", location.pathname);
installThemeColour(document);
const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("The canvassing application root is missing.");
try {
  const config = readBrowserConfig(
    import.meta.env as ConfigurationEnvironment,
    window.location,
  );
  const auth = new BrowserAuthManager(config, "groundspark_canvass_session_v1");
  const app = new CanvassApplication(root, auth, config);
  await app.start(fragment);
  if (import.meta.hot) import.meta.hot.dispose(() => void app.dispose());
} catch (failure) {
  root.replaceChildren(
    element(
      "main",
      "page",
      heading(1, "Canvassing could not start"),
      element("p", "error", message(failure)),
    ),
  );
}
